import { FC, ReactNode } from 'react'

import { ActionButton, BoxProps, IconName, Placeholder } from '@revolut-internal/ui-kit'

type CustomPlaceholderProps = {
  title: ReactNode
  description?: ReactNode
  icon?: IconName
  action?: {
    name: string
    onClick: VoidFunction
  }
} & Omit<BoxProps, 'action' | 'variant'>

export const CustomPlaceholder: FC<CustomPlaceholderProps> = ({
  title,
  description,
  action,
  icon,
  ...boxProps
}) => {
  return (
    <Placeholder {...boxProps}>
      {icon && <Placeholder.Image icon={icon} />}

      <Placeholder.Title>{title}</Placeholder.Title>

      {description && <Placeholder.Description>{description}</Placeholder.Description>}

      {action && (
        <Placeholder.Actions>
          {action.onClick ? (
            <ActionButton variant="accent" onClick={action.onClick}>
              {action.name}
            </ActionButton>
          ) : (
            action.name
          )}
        </Placeholder.Actions>
      )}
    </Placeholder>
  )
}
